import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface RemoveEmailVerificationResponse extends BackendResponse {}

export interface RemoveEmailVerificationParameters extends NextApiParams {
  email: string;
}

// Local-IP only on the backend — VPN/admin debugging affordance for re-testing
// the OTC flow.
export const removeEmailVerification = withNextApi<
  RemoveEmailVerificationResponse,
  RemoveEmailVerificationParameters
>("/auth/RemoveEmailVerification");
